import React, { Suspense, lazy, useEffect, useState } from 'react';
import { runWhenIdle } from '../../utils/idleCallback';

const PremiumAuthBoundary = lazy(() => import('./PremiumAuthBoundary'));
const immediatePremiumPaths = new Set(['/success', '/showPopup']);
const premiumPlaceholder = (
  <div
    aria-hidden="true"
    style={{
      height: '40px',
    }}
  />
);

export const shouldLoadPremiumFeaturesImmediately = (pathname = window.location.pathname) => (
  immediatePremiumPaths.has(pathname)
);

function PremiumFeaturesSlot(props) {
  const [shouldLoadPremiumFeatures, setShouldLoadPremiumFeatures] = useState(
    () => shouldLoadPremiumFeaturesImmediately()
  );

  useEffect(() => {
    if (shouldLoadPremiumFeatures) return undefined;

    return runWhenIdle(() => setShouldLoadPremiumFeatures(true), { timeout: 10000 });
  }, [shouldLoadPremiumFeatures]);

  if (!shouldLoadPremiumFeatures) {
    return premiumPlaceholder;
  }

  return (
    <Suspense fallback={premiumPlaceholder}>
      <PremiumAuthBoundary {...props} />
    </Suspense>
  );
}

export default PremiumFeaturesSlot;
